import React, { useState, useEffect } from 'react';
import { FaPlus, FaEdit, FaTrash, FaCheck, FaTimes } from 'react-icons/fa';
import { regionsService } from '../../services/sportsManagementService';
import { Modal, message } from 'antd';
import './SportsManagementStyle.scss';

const RegionsManagement = ({ userRegions }) => {
    const [regions, setRegions] = useState([]);
    const [loading, setLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [editingRegion, setEditingRegion] = useState(null);
    const [formData, setFormData] = useState({
        regionName: '',
        description: '',
        address: '',
        isActive: true
    });

    useEffect(() => {
        loadRegions();
    }, []);

    const loadRegions = async () => {
        setLoading(true);
        try {
            const res = await regionsService.getAll();
            if (res?.isSuccess) {
                let fetchedRegions = res.data;
                if (userRegions && userRegions.length > 0) {
                    const assignedIds = userRegions.map(ur => ur.id);
                    // Filter the fetched regions to only those in assignedIds
                    // Only apply filter if it's a regional user, which we can infer if userRegions is explicitly passed and restricted
                    const userRole = JSON.parse(localStorage.getItem('user') || '{}').userType?.toLowerCase();
                    if (userRole === 'regionalsports') {
                        fetchedRegions = fetchedRegions.filter(r => assignedIds.includes(r.regionId));
                    }
                }
                setRegions(fetchedRegions);
            }
        } catch (error) {
            console.error('Bölgeler yüklenirken hata oluştu:', error);
            message.error('Bölgeler yüklenemedi.');
        } finally {
            setLoading(false);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            if (editingRegion) {
                await regionsService.update(editingRegion.regionId, { ...formData, regionId: editingRegion.regionId });
                message.success('Bölge güncellendi.');
            } else {
                await regionsService.create(formData);
                message.success('Bölge oluşturuldu.');
            }
            setShowModal(false);
            resetForm();
            loadRegions();
        } catch (error) {
            console.error('İşlem hatası:', error);
            message.error('İşlem sırasında bir hata oluştu.');
        }
    };

    const handleDelete = async (id) => {
        Modal.confirm({
            title: 'Onay',
            content: 'Bu bölgeyi silmek istediğinizden emin misiniz?',
            okText: 'Evet',
            cancelText: 'Hayır',
            onOk: async () => {
                try {
                    await regionsService.delete(id);
                    message.success('Bölge silindi.');
                    loadRegions();
                } catch (error) {
                    console.error('Silme hatası:', error);
                    message.error('Bölge silinemedi. Bağlı tesisler olabilir.');
                }
            }
        });
    };

    const openEditModal = (region) => {
        setEditingRegion(region);
        setFormData({
            regionName: region.regionName,
            description: region.description || '',
            address: region.address || '',
            isActive: region.isActive
        });
        setShowModal(true);
    };

    const resetForm = () => {
        setEditingRegion(null);
        setFormData({ regionName: '', description: '', address: '', isActive: true });
    };

    return (
        <div className="sports-management-page">
            <div className="page-header">
                <h1>Spor Bölgeleri Yönetimi</h1>
                <button className="btn-premium header-add-btn" onClick={() => { resetForm(); setShowModal(true); }}>
                    <FaPlus /> Yeni Bölge Ekle
                </button>
            </div>

            <div className="premium-card">
                <div className="card-header">
                    <h3>Bölgeler Listesi</h3>
                </div>
                <div className="card-body">
                    {loading ? (
                        <div className="loading-spinner">Yükleniyor...</div>
                    ) : (
                        <div className="table-responsive">
                            <table className="data-table">
                                <thead>
                                    <tr>
                                        <th>Bölge Adı</th>
                                        <th>Açıklama</th>
                                        <th>Adres</th>
                                        <th>Durum</th>
                                        <th>İşlemler</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {regions.map((region) => (
                                        <tr key={region.regionId}>
                                            <td data-label="BÖLGE ADI"><span className="value">{region.regionName}</span></td>
                                            <td data-label="AÇIKLAMA"><span className="value">{region.description || '-'}</span></td>
                                            <td data-label="ADRES"><span className="value">{region.address || '-'}</span></td>
                                            <td data-label="DURUM">
                                                <span className={`status-badge ${region.isActive ? 'active' : 'inactive'}`}>
                                                    {region.isActive ? 'Aktif' : 'Pasif'}
                                                </span>
                                            </td>
                                            <td className="actions-cell" data-label="İŞLEMLER">
                                                <div className="action-buttons-wrapper">
                                                    <button className="btn-premium btn-sm btn-outline" onClick={() => openEditModal(region)}>
                                                        <FaEdit /> Düzenle
                                                    </button>
                                                    <button className="btn-premium btn-sm btn-danger" onClick={() => handleDelete(region.regionId)}>
                                                        <FaTrash /> Sil
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                    {regions.length === 0 && (
                                        <tr>
                                            <td colSpan="5" className="text-center">Kayıt bulunamadı.</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    )}
                </div>
            </div>

            {showModal && (
                <div className="modal-overlay">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h2>{editingRegion ? 'Bölge Düzenle' : 'Yeni Bölge Ekle'}</h2>
                            <button className="close-btn" onClick={() => setShowModal(false)}>&times;</button>
                        </div>
                        <form onSubmit={handleSubmit}>
                            <div className="modal-body">
                                <div className="form-group">
                                    <label>Bölge Adı</label>
                                    <input
                                        type="text"
                                        required
                                        maxLength="200"
                                        value={formData.regionName}
                                        onChange={(e) => setFormData({ ...formData, regionName: e.target.value })}
                                    />
                                </div>
                                <div className="form-group">
                                    <label>Açıklama</label>
                                    <textarea
                                        rows="2"
                                        maxLength="500"
                                        value={formData.description}
                                        onChange={(e) => setFormData({ ...formData, description: e.target.value })}
                                    />
                                </div>
                                <div className="form-group">
                                    <label>Adres</label>
                                    <textarea
                                        rows="2"
                                        maxLength="500"
                                        value={formData.address}
                                        onChange={(e) => setFormData({ ...formData, address: e.target.value })}
                                    />
                                </div>
                                {editingRegion && (
                                    <div className="form-group">
                                        <label>Durum</label>
                                        <div style={{ display: 'flex', gap: '1rem', alignItems: 'center' }}>
                                            <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', fontWeight: 'normal' }}>
                                                <input
                                                    type="radio"
                                                    checked={formData.isActive}
                                                    onChange={() => setFormData({ ...formData, isActive: true })}
                                                /> Aktif
                                            </label>
                                            <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', fontWeight: 'normal' }}>
                                                <input
                                                    type="radio"
                                                    checked={!formData.isActive}
                                                    onChange={() => setFormData({ ...formData, isActive: false })}
                                                /> Pasif
                                            </label>
                                        </div>
                                    </div>
                                )}
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn-premium btn-outline" onClick={() => setShowModal(false)}>İptal</button>
                                <button type="submit" className="btn-premium btn-success">
                                    <FaCheck /> Kaydet
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
};

export default RegionsManagement;
